import React, { useEffect } from 'react'
import { FaGithub, FaLinkedin, FaGitlab, FaInstagram, FaBlogger, FaDribbble } from 'react-icons/fa'
import AOS from 'aos';
import "aos/dist/aos.css";

const Social = () => {
    const links = [
        {
            id: 1,
            child: (
                <>
                    Linkedin <FaLinkedin size={30} />
                </>
            ),
            href: 'https://www.linkedin.com/in/fitrasalam/',
            style: 'bg-[#144377]'
        },
        {
            id: 2,
            child: (
                <>
                    Github <FaGithub size={30} />
                </>
            ),
            href: 'https://github.com/alamnaga',
            style: 'bg-black'
        },
        {
            id: 3,
            child: (
                <>
                    Gitlab <FaGitlab size={30} />
                </>
            ),
            href: 'https://gitlab.com/alamnaga',
            style: 'bg-[#e34329]'
        },
        {
            id: 4,
            child: (
                <>
                    Instagram <FaInstagram size={30} />
                </>
            ),
            href: 'https://www.instagram.com/snagalay/',
            style: 'bg-gradient-to-r from-[#002296] via-[#ea0c5f]  to-[#f6ba00]'
        },
        {
            id: 5,
            child: (
                <>
                    Blogspot <FaBlogger size={30} />
                </>
            ),
            href: 'https://alamnaga.blogspot.com/',
            style: 'bg-[#f16100]'
        },
        {
            id: 6,
            child: (
                <>
                    Dribbble <FaDribbble size={30} />
                </>
            ),
            href: 'https://dribbble.com/alamnaga',
            style: 'bg-[#ea4c89]'
        },
        
    ]
    useEffect(() => {
        AOS.init({ duration: 1000 });
        AOS.refresh();
      }, []);
    
    return (
        <div className='hidden lg:flex flex-col top-[25%] left-0 fixed' data-aos="fade-down-right" data-aos-delay="200" data-aos-once="true">
            <ul>
                {links.map(({ id, child, href, style }) => (
                    <li key={id} className={`flex justify-between items-center w-[9.5rem] h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 ${style}`}>
                <a href={href}
                    className='flex justify-between items-center w-full text-white'
                    target="_blank" rel='noreferrer'
                    >
                    {child}
                </a>
            </li>
            ))}

        </ul>
        </div >
    )
}

export default Social